import { EditableText, defineBlock } from "eddev/blocks"
import { Col, Container } from "@components/layout/Grid"
import { VSpace } from "@components/layout/Spacer"
import { useBreakpointIsFrom } from "@hooks/useViewportDerived"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { useSocialLinks } from "@hooks/queries"
import { Typography } from "@components/atoms/Typography"
import { SignupTrigger } from "@components/molecules/SignupForm"
import { Link, useHydrating } from "eddev/routing"
import { FACEBOOK, LINKEDIN, X, YOUTUBE } from "@components/atoms/Icons"

export const meta: BlockMeta = {
  title: "Get involved",
  category: "common",
  icon: "forms",
  keywords: ["form"],
  tags: ["root"],
  editMode: "preview",
  lazyLoad: false,
  conditions: {
    postTypes: ["page", "post"],
  },
}

export default defineBlock("general/get-involved", (props) => {
  const isLaptop = useBreakpointIsFrom("laptop")
  const hydrating = useHydrating()
  const socialLinks = useSocialLinks(undefined).data?.siteSettings?.themeSiteSettings?.socialMedia

  return (
    <Container className="my-6 p-6 bg-yellow rounded-md">
      <div className="grid w-full grid-cols-12 gap-6">
        <Col initial={12} tablet={6} laptop={7} className="order-2 md:order-1">
          <div className="flex flex-col mt-6 md:mt-0 md:pr-4 [&>span]:type-label-caps [&>span]:text-dark-grey [&_h3]:type-title-l [&_h3]:my-0 [&>p]:type-body-m [&>p]:my-0">
            <EditableText as="span" store="subtitle" placeholder="Enter subtitle..." />
            <VSpace initial={4} />
            <EditableText as="h3" store="title" placeholder="Enter title..." />
            <VSpace initial={4} />
            <EditableText as="p" store="content" placeholder="Enter content..." />
            <VSpace initial={8} />

            <div className="flex flex-col gap-6 md:gap-2 lg:flex-row lg:items-end lg:gap-6 [&>div:first-of-type]:grow">
              <SignupTrigger black />

              {!hydrating && socialLinks && (
                <div className="flex flex-col mt-4 gap-3 md:gap-2 [&>span]:w-full [&>div]:flex [&>div]:justify-start [&>div]:gap-2">
                  <Typography as="span" variant="caps">
                    Follow
                  </Typography>

                  <div>
                    {socialLinks.facebook && (
                      <Link
                        className="w-[42px] h-[42px] flex items-center justify-center rounded-md text-white bg-black hover:bg-dark-grey"
                        href={socialLinks.facebook}
                        target="_blank"
                      >
                        {FACEBOOK}
                      </Link>
                    )}
                    {socialLinks.x && (
                      <Link
                        className="w-[42px] h-[42px] flex items-center justify-center rounded-md text-white bg-black hover:bg-dark-grey"
                        href={socialLinks.x}
                        target="_blank"
                      >
                        {X}
                      </Link>
                    )}
                    {socialLinks.linkedin && (
                      <Link
                        className="w-[42px] h-[42px] flex items-center justify-center rounded-md text-white bg-black hover:bg-dark-grey"
                        href={socialLinks.linkedin}
                        target="_blank"
                      >
                        {LINKEDIN}
                      </Link>
                    )}
                    {socialLinks.youtube && (
                      <Link
                        className="w-[42px] h-[42px] flex items-center justify-center rounded-md text-white bg-black hover:bg-dark-grey"
                        href={socialLinks.youtube}
                        target="_blank"
                      >
                        {YOUTUBE}
                      </Link>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </Col>

        <Col initial={12} tablet={6} laptop={5} className="order-1 md:order-3">
          {props?.image && (
            <div className="rounded-[6px] overflow-hidden h-full [&>div]:pt-0 [&>div]:h-full [&_img]:relative">
              <ResponsiveImage {...props.image} objectFit="cover" />
            </div>
          )}
        </Col>
      </div>
    </Container>
  )
})
